import {creates, hoistCmp} from '@xh/hoist/core';
import {panel} from '@xh/hoist/desktop/cmp/panel';
import {chart, ChartModel} from '@xh/hoist/cmp/chart';
import {FearAndGreedWidgetModel} from './FearAndGreedWidgetModel';
import './FearAndGreedWidget.scss';
import {hframe} from '@xh/hoist/cmp/layout';
import {toolbar} from '@xh/hoist/desktop/cmp/toolbar';
import {button} from '@xh/hoist/desktop/cmp/button';
import {Icon} from '@xh/hoist/icon';
import {popover} from '@xh/hoist/kit/blueprint';
import {fmtNumber} from '@xh/hoist/format';
import {FearAndGreedTypeEnum} from '../../../../data/DataTypes';
import {chartLineUpDownIcon, faceAnxiousSweatIcon} from '../../../../../core/Icons';

export const fearAndGreedWidget = hoistCmp.factory({
    model: creates(() => FearAndGreedWidgetModel),
    render({model}) {
        return panel({
            className: 'fear-and-greed',
            items: hframe(chart({model: model.summaryChartModel}), itemList())
        });
    }
});

const itemList = hoistCmp.factory<FearAndGreedWidgetModel>(({model}) =>
    toolbar({
        vertical: true,
        className: 'fear-and-greed__toolbar',
        items: model.scoreDetails.map(sd =>
            popover({
                className: 'xh-no-pad',
                item: button({
                    icon: iconFactory(sd.type),
                    text: fmtNumber(sd.score, {precision: 1})
                }),
                interactionKind: 'hover',
                hoverCloseDelay: 50,
                content: itemDetails({model: model.getChartModel(sd.type)})
            })
        )
    })
);

const itemDetails = hoistCmp.factory<ChartModel>(({model}) =>
    panel({
        width: 500,
        height: 350,
        item: chart()
    })
);

function iconFactory(type: FearAndGreedTypeEnum) {
    switch (type) {
        case FearAndGreedTypeEnum.Index:
            return Icon.gauge();
        case FearAndGreedTypeEnum.MarketMomentum:
            return chartLineUpDownIcon();
        case FearAndGreedTypeEnum.StockPriceStrength:
            return Icon.arrowsUpDown();
        case FearAndGreedTypeEnum.StockPriceBreadth:
            return Icon.arrowsLeftRight();
        case FearAndGreedTypeEnum.PutCallOptions:
            return Icon.balanceScaleRight();
        case FearAndGreedTypeEnum.SafeHavenDemand:
            return Icon.shieldCheck();
        case FearAndGreedTypeEnum.JunkBondDemand:
            return Icon.trash();
        case FearAndGreedTypeEnum.MarketVolatility:
            return faceAnxiousSweatIcon();
    }
}
